import { Plus } from 'lucide-react';

import { Button } from './ui/button';

type Props = {
  children?: React.ReactNode;
  colSpan?: number;
};

export const EmptyRow = ({ children }: Props) => {
  return (
    <div className="flex flex-col items-center justify-center gap-3 text-muted-foreground">
      {children}
    </div>
  );
};

const ClearFiltersButton = ({
  title,
  children,
  onClear,
}: {
  title: string;
  children: React.ReactNode;
  onClear?: () => void;
}) => {
  return (
    <>
      <div className="space-y-1">
        <p className="text-sm font-bold">{title}</p>
        <p className="text-xs">{children}</p>
      </div>
      {onClear && (
        <Button variant="secondary" size="sm" onClick={onClear}>
          Clear filters
        </Button>
      )}
    </>
  );
};

const CreateNewButton = ({
  title,
  buttonText,
  children,
  onCreate,
}: {
  title: string;
  children: React.ReactNode;
  buttonText: string;
  onCreate: () => void;
}) => {
  return (
    <>
      <div className="space-y-1">
        <p className="text-sm font-bold">{title}</p>
        <p className="text-xs">{children}</p>
      </div>
      <Button variant="default" size="sm" onClick={onCreate}>
        <Plus className="h-4 w-4 mr-1" />
        {buttonText}
      </Button>
    </>
  );
};

EmptyRow.ClearFiltersButton = ClearFiltersButton;
EmptyRow.CreateNewButton = CreateNewButton;
